import { useState, useEffect, SetStateAction } from "react";
import { useCurrentUser, useCentralApi } from "hooks/shared";

export interface IWorkItemSearchStatuses {
  id: number;
  name: string;
}

export interface IWorkItemStatuses {
  value: number;
  label: string;
}

export interface IWorkItemStatusValidTransitions {
  fromStatus: number;
  toStatus: number;
}

export type WorkItemPossibleStatus = {
  workItemSearchStatuses: IWorkItemSearchStatuses[];
   workItemStatuses : IWorkItemStatuses[];
  workItemStatusValidTransitions: IWorkItemStatusValidTransitions[];
};

const getWorkItemBulkUpdateStatuses = (WorkItemStatusValidTransitions: any[], WorkItemStatuses: any[]) => {
return WorkItemStatusValidTransitions
       .flatMap(transition => [transition.fromStatus, transition.toStatus])
       .reduce((acc: number[], value) => {
  if (!acc.includes(value)) {
     acc.push(value);
  }
  return acc;
}, [])
  .map(value => {
    const supportedBulkUpdateStatus = WorkItemStatuses.find(status => status.value === value);
    if (supportedBulkUpdateStatus) {
      return { id: supportedBulkUpdateStatus.value, name: supportedBulkUpdateStatus.label };
    }
    return null;
  })
.filter(status => status !== null);
}

// Component
const useWorkItemPossibleStatus = (): {
  WorkItemBulkUpdateStatuses: IWorkItemSearchStatuses[];
  WorkItemSearchStatuses: IWorkItemSearchStatuses[];
  WorkItemResourcesSearchStatuses: IWorkItemSearchStatuses[];
  WorkItemStatuses: IWorkItemStatuses[],
  WorkItemStatusValidTransitions:IWorkItemStatusValidTransitions[],
  WorkItemStatusLoading: boolean;
} => {

  const [WorkItemSearchStatuses, setWorkItemSearchStatuses] = useState<any[]>([]);
  const [WorkItemResourcesSearchStatuses, setWorkItemResourcesSearchStatuses] = useState<any[]>([]);
  const [WorkItemStatuses, setWorkItemStatuses] = useState<any[]>([]);
  const [WorkItemStatusValidTransitions, setWorkItemStatusValidTransitions] = useState<any[]>([]);
  const [WorkItemBulkUpdateStatuses, setWorkItemBulkUpdateStatuses] = useState<any[]>([]);
  const [WorkItemStatusLoading, setWorkItemStatusLoading] = useState<boolean>(true);

  const user = useCurrentUser();
  const fetcher = useCentralApi(user);
  const controller = new AbortController();
  useEffect(() => {
    const getPossibleStatus = async () => {
      setWorkItemStatusLoading(true);
      if (user && user.id_token) {
        const resp = await fetcher(
          "/api/v3/bulkupdate/workitem/supported-work-item-status",
          {
            method: "GET",
            signal: controller.signal,
          }
        );
        if (!resp.ok) {
          // RESPOND TO ERRORS
          setWorkItemStatusLoading(false);
          console.error('failed to load work item status data');
        }
       const response = await resp.json();
       if (response) {
         const workItemPossibleStatusData = response as WorkItemPossibleStatus;
         const workItemSearchStatusesData: IWorkItemSearchStatuses[] = workItemPossibleStatusData.workItemSearchStatuses;
         const workItemStatusesData: IWorkItemStatuses[] = workItemPossibleStatusData.workItemStatuses;
         const workItemStatusValidTransitionsData: IWorkItemStatusValidTransitions[] = workItemPossibleStatusData.workItemStatusValidTransitions;
         const WorkItemBulkUpdateStatuses = getWorkItemBulkUpdateStatuses(workItemStatusValidTransitionsData,workItemStatusesData)
         setWorkItemBulkUpdateStatuses(WorkItemBulkUpdateStatuses);
         setWorkItemSearchStatuses(workItemSearchStatusesData);         
         setWorkItemResourcesSearchStatuses(workItemStatusesData.filter(x => x.value <= 3).map(x => {return {id: x.value, name: x.label } }));
         setWorkItemStatuses(workItemStatusesData);
         setWorkItemStatusValidTransitions(workItemStatusValidTransitionsData);
         setWorkItemStatusLoading(false);
       }
        
      }
    };

    getPossibleStatus().catch((err) => {
      setWorkItemStatusLoading(false);
      console.error('failed to load work item status data')
    });
  }, [user]);
  return {
    WorkItemBulkUpdateStatuses,
    WorkItemSearchStatuses,
    WorkItemResourcesSearchStatuses,
    WorkItemStatuses,
    WorkItemStatusValidTransitions,
    WorkItemStatusLoading,
  };
};

export default useWorkItemPossibleStatus;
